<template>
    <v-container>
        <v-row>
            <v-col>

                <div class="headline">Brukere</div>
                <br>

                <v-row align="center" class="elevation-1 white px-3 mx-1">
                    <v-col cols="auto">
                        <v-btn :disabled="this.$store.getters.rights > 0" @click="newUser.show = true" color="success">
                            <v-icon left>mdi-plus-circle-outline</v-icon>
                            Ny bruker
                        </v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-autocomplete v-model="companyToFilterBy" :items="companies" item-text="name" label="bedrifter å filtrere på" hide-details clearable multiple return-object></v-autocomplete>
                    </v-col>
                    <v-col cols="auto">
                        <v-text-field v-model="textToFilterBy" hide-details clearable label="søk" append-icon="mdi-magnify"></v-text-field>
                    </v-col>
                    <v-col cols="auto">
                        <v-switch v-model="filterOnActive" label="Filtrer inaktive brukere" hide-details></v-switch>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table :headers="headers" :items="filteredUsers" :loading="usersLoading" hide-default-footer :items-per-page="-1" :mobile-breakpoint=0>
                            <template v-slot:item={item}>
                                <tr @click="editUser(item)" :class="item.active ? '': 'red lighten-5'" style="cursor:pointer; white-space: nowrap">
                                    <td>
                                        {{item.name}}
                                        <v-icon v-if="item.id == $store.getters.userId">mdi-account</v-icon>
                                        <v-icon v-if="!item.active">mdi-account-cancel</v-icon>
                                    </td>
                                    <td>{{item.username}}</td>
                                    <td>{{item.phone}}</td>
                                    <td>{{item.company ? item.company.name : ''}}</td>
                                    <td>{{item.accessCodeCount}}</td>
                                    <td class="justify-center layout px-0">
                                        <v-icon :disabled="$store.getters.rights > 0" @click.stop="editUser(item)" color="info">mdi-pencil</v-icon>
                                        <v-icon :disabled="$store.getters.rights > 0" @click.stop="confirmDeleteUser(item)" color="info">mdi-delete</v-icon>
                                        <v-icon v-if="item.id != $store.getters.userId" :disabled="$store.getters.rights > 0" @click.stop="confirmPasswordReset(item)" color="info">mdi-lock-reset</v-icon>
                                        <v-icon v-if="item.id == $store.getters.userId" @click.stop="confirmPasswordChange(item)" color="info">mdi-shield-account</v-icon>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-dialog :disabled="this.$store.getters.rights > 0" v-model="newUser.show" persistent width="50%" @keydown.esc="cancel">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    Ny bruker
                    <v-spacer></v-spacer>
                    <v-btn fab small @click="cancel">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="newUser.valid" compact>
                        <v-text-field label="Navn" v-model="newUser.name" type="text" :rules="[v => !!v && v.length > 0 || 'Påkrevd']"></v-text-field>
                        <v-text-field label="Brukernavn/e-post" v-model="newUser.username" type="text" :rules="[v => !!v && v.length > 0 || 'Påkrevd']"></v-text-field>
                        <v-text-field label="Passord" v-model="newUser.password" type="password" :rules="[v => !!v && v.length > 0 || 'Påkrevd']"></v-text-field>
                        <v-text-field label="Telefon" v-model="newUser.phone" type="text" :rules="[v => !!v && v.length > 0 || 'Påkrevd']"></v-text-field>
                        <v-select label="Bedrift" v-model="newUser.company" :items="companies" item-value="id" item-text="name" dense return-object chips></v-select>

                        <br>
                        <div class="body-1">Bruker rettigheter:</div>
                        <hr>

                        <v-radio-group v-model="newUser.canLogin">
                            <v-radio :value=1>
                                <template v-slot:label>
                                    <div>Bruker kan logge inn i Gatebrains.</div>
                                </template>
                            </v-radio>
                            <v-radio :value=0>
                                <template v-slot:label>
                                    <div>Bruker kan ikke logge inn i Gatebrains.</div>
                                </template>
                            </v-radio>
                        </v-radio-group>

                        <hr>

                        <v-radio-group v-model="newUser.rights">
                            <v-radio :value=1>
                                <template v-slot:label>
                                    <div>Vanlig bruker.</div>
                                </template>
                            </v-radio>
                            <v-radio :value=0>
                                <template v-slot:label>
                                    <div>Administrator.</div>
                                </template>
                            </v-radio>
                        </v-radio-group>

                        <hr>

                        <v-radio-group v-model="newUser.active">
                            <v-radio :value=1>
                                <template v-slot:label>
                                    <div>Bruker er aktivt (synlig systemet og kan logge inn).</div>
                                </template>
                            </v-radio>
                            <v-radio :value=0>
                                <template v-slot:label>
                                    <div>Bruker er inaktivt (er usynlig i systemet og kan ikke logge inn).</div>
                                </template>
                            </v-radio>
                        </v-radio-group>

                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancel">Avbryt</v-btn>
                    <v-btn color="success" @click="save">Lagre</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showPasswordChange" persistent>
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    Endre passord: {{userToChangePassword ? userToChangePassword.name : ''}} - {{userToChangePassword ? userToChangePassword.username : ''}}
                </v-card-title>

                <v-card-text>
                    <v-form v-model="userChangePasswordValid" ref="changeForm">
                        <v-text-field v-model="userNewPassword" type="password" label="passord" required :rules="[v => !!v || 'Påkrevd']"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancelPasswordChange">Avbryt</v-btn>
                    <v-btn @click="okPasswordChange" color="success">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showPasswordReset">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    Nullstill passord?
                </v-card-title>

                <v-card-text>
                    {{userToResetPassword ? userToResetPassword.name : ''}} - {{userToResetPassword ? userToResetPassword.username : ''}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancelPasswordReset">Avbryt</v-btn>
                    <v-btn @click="okPasswordReset" color="success">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="showDelete" persistent max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    Slett bruker?
                </v-card-title>

                <v-card-text>
                    {{userToDelete ? userToDelete.name : ''}} - {{userToDelete ? userToDelete.username : ''}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancelDeleteUser">Avbryt</v-btn>
                    <v-btn @click="okDeleteUser" color="success">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import axios from "axios";
export default {
    data() {
        return {
            filterOnActive: false,
            users: [],
            usersLoading: false,
            // filteredUsers: [],
            companyToFilterBy: [],
            textToFilterBy: "",
            headers: [
                {
                    text: "Navn",
                    value: "name",
                    align: "left",
                    sortable: true,
                    width: "20%"
                },
                {
                    text: "Brukernavn/Epost",
                    value: "username",
                    sortable: false,
                    width: "20%"
                },
                { text: "Tlf", value: "phone", sortable: false, width: "15%" },
                {
                    text: "Bedrift",
                    value: "company",
                    sortable: false,
                    width: "25%"
                },
                {
                    text: "Antall tilganger",
                    value: "accessCodeCount",
                    sortable: true,
                    width: "5%"
                },
                {
                    text: "Handlinger",
                    value: "actions",
                    sortable: false,
                    width: "10%"
                }
            ],
            newUser: {
                show: false,
                valid: true,
                name: "",
                username: "",
                password: "",
                phone: "",
                company_id: null,
                company: {},
                canLogin: 1,
                rights: 1,
                active: 1
            },
            companies: [],
            showDelete: false,
            userToDelete: null,
            showPasswordReset: false,
            userToResetPassword: null,
            showPasswordChange: false,
            userToChangePassword: null,
            userChangePasswordValid: true,
            userNewPassword: ""
        };
    },
    computed: {
        filteredUsers: function() {
            // companies
            let users = this.users.filter(u => {
                if (this.companyToFilterBy.length == 0) return true;

                if (!("company" in u) || !u.company || u.company.id == 0) return false;

                return this.companyToFilterBy.map(c => c.id).includes(u.company.id);
            });

            if (!!this.textToFilterBy && this.textToFilterBy.trim()) {
                users = users.filter(u => {
                    return (
                        u.phone
                            .toLowerCase()
                            .trim()
                            .includes(this.textToFilterBy.toLowerCase().trim()) ||
                        u.name
                            .toLowerCase()
                            .trim()
                            .includes(this.textToFilterBy.toLowerCase().trim())
                    );
                    // return u.name.toLowerCase().trim().includes(this.textToFilterBy.toLowerCase().trim());
                });
            }

            return this.filterOnActive ? users.filter(u => u.active) : users;
        }
    },
    methods: {
        // filterUsers: function() {
        //     // companies
        //     this.filterUsers = this.users.filter(u => {
        //         if (this.companyToFilterBy.length == 0) {
        //             return true;
        //         }
        //     });
        // },
        confirmPasswordChange: function(user) {
            this.userNewPassword = "";
            this.userToChangePassword = user;
            this.showPasswordChange = true;
        },
        okPasswordChange: function() {
            if (this.$refs.changeForm.validate()) {
                // send email with new password
                this.axios
                    .post(`/user/${this.userToChangePassword.id}/changepassword`, { password: this.userNewPassword })
                    .then(response => {
                        if (response.data.success) {
                            this.$store.commit("snackbar", {
                                text: `Passord endret.`,
                                color: "success",
                                show: true
                            });
                        } else throw new Error();
                    })
                    .catch(() => {
                        this.$store.commit("snackbar", {
                            text: `Passord ikke endret.`,
                            color: "error",
                            show: true
                        });
                    });

                this.userNewPassword = "";
                this.showPasswordChange = false;
                this.userToChangePassword = null;
            }
        },
        cancelPasswordChange: function() {
            this.userNewPassword = "";
            this.showPasswordChange = false;
            this.userToChangePassword = null;
        },

        confirmPasswordReset: function(user) {
            this.userToResetPassword = user;
            this.showPasswordReset = true;
        },
        okPasswordReset: function() {
            // send email with new password
            this.axios
                .post(`/user/${this.userToResetPassword.id}/resetpassword`)
                .then(response => {
                    if (response.data.success) {
                        this.$store.commit("snackbar", {
                            text: `Passord nullstilt.`,
                            color: "success",
                            show: true
                        });
                    } else throw new Error();
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `Passord ikke nullstilt.`,
                        color: "error",
                        show: true
                    });
                });

            this.showPasswordReset = false;
            this.userToResetPassword = null;
        },
        cancelPasswordReset: function() {
            this.showPasswordReset = false;
            this.userToResetPassword = null;
        },
        confirmDeleteUser: function(user) {
            this.userToDelete = user;
            this.showDelete = true;
        },
        okDeleteUser: function() {
            this.axios
                .delete(`/user/${this.userToDelete.id}`)
                .then(response => {
                    if (response.data.success) {
                        this.$store.commit("snackbar", {
                            text: `Bruker slettet.`,
                            color: "success",
                            show: true
                        });
                        return;
                    }

                    throw new Error("User not deleted");
                })
                .catch(() => {
                    this.$store.commit("snackbar", {
                        text: `Bruker ikke slettet.`,
                        color: "error",
                        show: true
                    });
                });

            let index = this.users.findIndex(u => u.id == this.userToDelete.id);
            if (index >= 0) {
                this.users.splice(index, 1);
            }

            this.showDelete = false;
            this.userToDelete = null;
        },
        cancelDeleteUser: function() {
            this.showDelete = false;
            this.userToDelete = null;
        },
        editUser: function(user) {
            this.$router.push(`/user/${user.id}`);
        },
        save: function() {
            var that = this;
            if (this.$refs.form.validate()) {
                // save new user
                this.axios
                    .put("/user", {
                        name: that.newUser.name,
                        username: that.newUser.username.trim(),
                        password: that.newUser.password,
                        phone: that.newUser.phone.trim(),
                        rights: that.newUser.rights,
                        canLogin: that.newUser.canLogin,
                        active: that.newUser.active,
                        company_id: that.newUser.company ? that.newUser.company.id : null
                    })
                    .then(response => {
                        if (response.data.success) {
                            let u = response.data.data;
                            u.company = that.newUser.company;
                            that.users.push(u);

                            // clear new user
                            that.newUser.name = "";
                            that.newUser.username = "";
                            that.newUser.password = "";
                            that.newUser.phone = "";
                            that.newUser.company_id = null;
                            that.newUser.company = {};
                            that.newUser.canLogin = 1;
                            that.newUser.rights = 1;
                            that.newUser.active = 1;
                            // close dialog
                            that.newUser.show = false;
                            that.newUser.valid = true;

                            this.companyToFilterBy.splice(0, this.companyToFilterBy.length);
                            this.textToFilterBy = "";
                        }
                    });
            }
        },
        cancel: function() {
            // clear new user
            this.newUser.name = "";
            this.newUser.username = "";
            this.newUser.password = "";
            this.newUser.phone = "";
            this.newUser.company_id = null;
            this.newUser.company = {};
            this.newUser.canLogin = 1;
            this.newUser.rights = 1;
            this.newUser.active = 1;
            // close dialog
            this.newUser.show = false;
            this.newUser.valid = true;
        }
    },
    mounted() {
        this.usersLoading = true;
        this.axios
            .get("/user")
            .then(response => {
                if (response.data.success) {
                    this.users = response.data.data;
                } else {
                    // TODO snackbar
                }
            })
            .catch(() => {
                // TODO snackbar
                // console.log(err);
            })
            .finally(() => {
                this.usersLoading = false;
            });

        this.axios.get("/company").then(response => {
            this.companies = response.data.data.sort((a, b) => {
                if (a.name < b.name) return -1;
                else if (a.name > b.name) return 1;
                else return 0;
            });
        });
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style scoped>
</style>
